import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=d06ffde4&scoped=true&"
import script from "./Reports.vue?vue&type=script&lang=js&"
export * from "./Reports.vue?vue&type=script&lang=js&"
import style0 from "./Reports.vue?vue&type=style&index=0&id=d06ffde4&scoped=true&lang=scss&"
import style1 from "./Reports.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06ffde4",
  null
  
)

export default component.exports